export default {
	changelog_menu_item: 'Changelog',
	changelog_no_entries: 'Noch keine Einträge',
	changelog_section_seen: 'Bereits gelesen',
	changelog_section_unseen: 'Neu',
	changelog_title: 'Was ist neu',
	changelog_unseen_tooltip: 'Neue Version verfügbar',
	changelog_version_label: 'Version',
};
